var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row basemap-ogc" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        !_vm.readonlyFormItem
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("TableData", {
                  attrs: {
                    showTitleData: false,
                    baseClass: "mb-0",
                    tableWrapperClass: "py-2 px-1",
                    startLoad: _vm.startLoadResources,
                    route: _vm.basemapUrl,
                    settings: _vm.table.settings,
                    columns: _vm.table.columns(),
                    inlineFilters: _vm.table.filters,
                    autoUpdateFilter: _vm.table.autoUpdateFilter,
                    externalFilters: _vm.tblFilters,
                    autoUpdateExternalFilter:
                      _vm.table.autoUpdateExternalFilter,
                    addParamsToUrl: _vm.table.addParamsToUrl,
                    loadingMsg: _vm.table.loadingMsg,
                    notFoundMsg: _vm.table.notFoundMsg,
                    orderByTemplate: _vm.table.orderByTemplate,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "filters",
                        fn: function ({ tableFilters, search }) {
                          return [
                            _c(
                              "form",
                              {
                                attrs: { autocomplete: "false" },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return search.apply(null, arguments)
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return search.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "row header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c("HeaderList", {
                                        attrs: {
                                          title: null,
                                          placeholderSearch: _vm.$t(
                                            `${_vm.translatedId}.list.placeholder_search`
                                          ),
                                          headerClass: "mb-3",
                                        },
                                        model: {
                                          value: tableFilters.q,
                                          callback: function ($$v) {
                                            _vm.$set(tableFilters, "q", $$v)
                                          },
                                          expression: "tableFilters.q",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "body",
                        fn: function ({ row, columns, index }) {
                          return [
                            !_vm.eligibleForCrossResource(row.service) ||
                            (_vm.enableVectorLayer &&
                              _vm.eligibleForCrossResource(row.service))
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "px-0",
                                    class: columns[0].class,
                                  },
                                  [
                                    _c("ResourceItemList", {
                                      attrs: {
                                        value: row,
                                        enableCrossResource:
                                          _vm.enableCrossresources,
                                        readonlyForm: _vm.readonlyFormItem,
                                      },
                                      on: {
                                        addResource: function ($event) {
                                          return _vm.addResource(
                                            row,
                                            index,
                                            _vm.onSelectedItem
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3047684381
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }